import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  twcPageContainer: {
    height: '100%',
    width: '100%',
  },
});
